// <video data-controller="lazy-video"
//        data-lazy-video-src-value="/uploads/entries/videos/clip.mp4"
//        data-lazy-video-poster-value="/uploads/entries/promo.jpg"></video>
//
// Browsers ignore loading="lazy" on <video>, so the video renders without
// src/poster and gets them once it comes within about a screen of view.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { src: String, poster: String }

  connect() {
    if (this.element.getAttribute("src")) return

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.load()
    }, { rootMargin: "100% 0px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  load() {
    this.observer.disconnect()
    if (this.posterValue) this.element.poster = this.posterValue
    this.element.src = this.srcValue
  }
}
